import React, { useEffect, useState, useContext } from 'react';
import styled from 'styled-components';
import firebase from 'gatsby-plugin-firebase';

import SEO from '../seo';
import Wrapper from '../elements/wrapper';
import WishlistGridItem from './wishlist-grid-item';
import { media } from '../helpers';
import { FirebaseContext } from '../../context/FirebaseContext';

const WishlistContainer = styled.div`
    .title-container {
        h1 {
            font-weight: 800;
            font-family: neue-kabel, sans-serif;
            font-size: 1.8rem;
            color: #0f1212;
        }
    }
    .wishlist-items-wrapper {
        ${media.medium`display: flex; flex-wrap: wrap;`}

        > * {
            flex: 0 0 33.33%;
        }
    }
`;

const Wishlist = () => {
    const [wishlist, setWishlist] = useState([]);
    const { user } = useContext(FirebaseContext);
    useEffect(() => {
        if (user) {
            firebase
                .database()
                .ref('users/' + user.id + '/wishlist')
                .on('value', function (snapshot) {
                    if (snapshot.val() !== null) {
                        const arrayOfObj = [];
                        Object.entries(snapshot.val()).map((e) => {
                            let wishlistItem = {
                                id: e[0],
                                product: {
                                    handle: e[1].handle,
                                    variant: e[1].variant,
                                },
                            };
                            arrayOfObj.push(wishlistItem);
                        });
                        // console.log(arrayOfObj);

                        setWishlist(arrayOfObj);
                    } else {
                        setWishlist([]);
                    }
                });
            // .then((snapshot) => {

            // });
        }
        // console.log(wishlist);
    }, [user]);

    return (
        <WishlistContainer>
            <SEO title="Dashboard –– My Design Board" />
            <Wrapper className="title-container">
                <h1>My Design Board</h1>
            </Wrapper>
            <Wrapper className="wishlist-items-wrapper">
                {wishlist.length > 0 &&
                    wishlist.map((item, index) => {
                        const { id, product } = item;
                        return (
                            <WishlistGridItem
                                key={index}
                                handle={product.handle}
                                variant={product.variant}
                                itemId={id}
                            />
                        );
                    })}
            </Wrapper>
        </WishlistContainer>
    );
};

export default Wishlist;
